import UserJobPost from 'types/jobPosts';
import axiosRequest from './restapi';

export const getAllJobPosts = (userToken: string, filter: string = '') => {
  return axiosRequest(
    {
      method: 'get',
      url: `/recruiters/all-jobs${filter.length ? `?filter=${filter}` : filter}`,
    },
    userToken
  );
};

export const getUserJobPosts = (userRole: string, userToken: string) => {
  return axiosRequest(
    {
      method: 'get',
      url: `${userRole.toLowerCase()}s/jobs?filter={"order":["createdAt DESC"]}`,
    },
    userToken
  );
};

export const setUserJobPost = (data: UserJobPost, userToken: string) => {
  return axiosRequest(
    {
      method: 'post',
      url: 'employers/jobs',
      data,
    },
    userToken
  );
};

export const changeUserJobPost = (data: UserJobPost, jobPostId: number, userToken: string) => {
  return axiosRequest(
    {
      method: 'patch',
      url: `jobs/${jobPostId}`,
      data,
    },
    userToken
  );
};

export const deleteUserJobPost = (jobPostId: number, userToken: string) => {
  return axiosRequest(
    {
      method: 'delete',
      url: `employers/jobs/${jobPostId}`,
    },
    userToken
  );
};

export const setRecruiterJobPost = (jobId: number, userToken: string) => {
  return axiosRequest(
    {
      method: 'post',
      url: 'recruiters/jobs',
      data: { jobId },
    },
    userToken
  );
};

export const deleteRecruiterJobPost = (jobId: number, userToken: string) => {
  return axiosRequest(
    {
      method: 'delete',
      url: `/recruiters/jobs/${jobId}`,
    },
    userToken
  );
};
